var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconFrequently38X38 = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 39,
  height: 38,
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.33 3.126a.992.992 0 0 1 .36 1.355l-2.78 4.791h11.375l-2.786-4.79a.992.992 0 1 1 1.714-.997l3.366 5.787h5.441c.767 0 1.389.622 1.389 1.389h-.014c0 .767-.621 1.388-1.388 1.388H28.91L26.9 26.937a2.762 2.762 0 0 1-2.737 2.367H9.553a2.762 2.762 0 0 1-2.737-2.367l-2.01-14.888H3.709a1.388 1.388 0 1 1 0-2.777h4.909l3.357-5.786a.992.992 0 0 1 1.356-.36Zm-1.754 11.647c.365 0 .66.296.66.66v7.934a.661.661 0 0 1-1.321 0v-7.933c0-.365.296-.661.66-.661Zm5.95.66a.661.661 0 0 0-1.323 0v7.934a.661.661 0 0 0 1.323 0v-7.933Zm4.627-.66c.365 0 .661.296.661.66v7.934a.661.661 0 0 1-1.322 0v-7.933c0-.365.296-.661.661-.661Z",
  fill: "#2D91FF"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M28.094 17.375c-5.31 0-9.624 4.29-9.624 9.58s4.314 9.58 9.624 9.58c5.31 0 9.623-4.29 9.623-9.58s-4.313-9.58-9.623-9.58Z",
  fill: "#2D91FF",
  stroke: "#fff",
  strokeWidth: 1.068
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "m28.806 24.18-2.666-1.537v.011a.714.714 0 0 1 0-1.238l2.666-1.537a.287.287 0 0 1 .434.243v1.265c2.72.51 4.779 2.888 4.779 5.742 0 3.226-2.631 5.844-5.873 5.844-3.242 0-5.873-2.618-5.873-5.844 0-.406.331-.735.74-.735.407 0 .738.329.738.735 0 2.414 1.97 4.373 4.395 4.373s4.395-1.96 4.395-4.373a4.382 4.382 0 0 0-3.301-4.236v1.044a.287.287 0 0 1-.433.243Z",
  fill: "#fff"
})));
export default SvgIconFrequently38X38;